module.exports = __webpack_public_path__ + "img/fi.c7d5979a.svg";